(() => {
  const desktopPointer = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const edgeSize = 56;
  const maxSpeed = 12;
  const active = new Map();

  function stop(scroller) {
    const state = active.get(scroller);
    if (!state) return;
    if (state.frame) cancelAnimationFrame(state.frame);
    active.delete(scroller);
  }

  function stopAll() {
    Array.from(active.keys()).forEach(stop);
  }

  function tick(scroller) {
    const state = active.get(scroller);
    if (!state || !state.speed) return stop(scroller);

    const maxScroll = scroller.scrollHeight - scroller.clientHeight;
    if (maxScroll <= 1) return stop(scroller);

    scroller.scrollTop = Math.max(0, Math.min(maxScroll, scroller.scrollTop + state.speed));

    if ((state.speed > 0 && scroller.scrollTop >= maxScroll) || (state.speed < 0 && scroller.scrollTop <= 0)) {
      return stop(scroller);
    }

    state.frame = requestAnimationFrame(() => tick(scroller));
  }

  function setSpeed(scroller, speed) {
    if (!speed) return stop(scroller);

    const state = active.get(scroller);
    if (state) {
      state.speed = speed;
      return;
    }

    const next = { speed, frame: null };
    active.set(scroller, next);
    next.frame = requestAnimationFrame(() => tick(scroller));
  }

  function getScroller(target) {
    if (!(target instanceof Element)) return null;
    const host = target.closest('header-menu');
    if (!host) return null;

    const details = host.querySelector(':scope > details');
    if (!details || !details.open) return null;

    const scroller = details.querySelector(':scope > .header__submenu, :scope > .mega-menu__content');
    if (!scroller || scroller.scrollHeight <= scroller.clientHeight + 1) return null;
    return scroller;
  }

  document.addEventListener(
    'pointermove',
    (event) => {
      if (!desktopPointer.matches || reducedMotion.matches) {
        stopAll();
        return;
      }

      const scroller = getScroller(event.target);
      Array.from(active.keys()).forEach((item) => {
        if (item !== scroller) stop(item);
      });
      if (!scroller) return;

      const rect = scroller.getBoundingClientRect();
      const topDistance = event.clientY - rect.top;
      const bottomDistance = rect.bottom - event.clientY;
      let speed = 0;

      if (topDistance >= 0 && topDistance < edgeSize && scroller.scrollTop > 0) {
        speed = -Math.max(2, Math.round(maxSpeed * (1 - topDistance / edgeSize)));
      } else if (
        bottomDistance >= 0 &&
        bottomDistance < edgeSize &&
        scroller.scrollTop < scroller.scrollHeight - scroller.clientHeight
      ) {
        speed = Math.max(2, Math.round(maxSpeed * (1 - bottomDistance / edgeSize)));
      }

      setSpeed(scroller, speed);
    },
    { passive: true }
  );

  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || details.open || !details.closest('header-menu')) return;
      const scroller = details.querySelector(':scope > .header__submenu, :scope > .mega-menu__content');
      if (scroller) stop(scroller);
    },
    true
  );

  document.documentElement.addEventListener('pointerleave', stopAll, { passive: true });
  window.addEventListener('blur', stopAll);
  desktopPointer.addEventListener('change', stopAll);
  reducedMotion.addEventListener('change', stopAll);
})();
